import gql from 'graphql-tag';

export class UserMutations {
  static updateUserV2 = gql`
    mutation updateUserV2($userPayload: UpdateUserArgsV2!, $userId: String!) {
      updateUserV2(userPayload: $userPayload, userId: $userId)
    }
  `;

  static updateUserProfile = gql`
    mutation updateUserProfile(
      $userRole: UserRole
      $userStatus: UserStatus
      $appMode: UserProfileAppMode
      $showTeam: Boolean
      $showAll: Boolean
      $userId: String!
    ) {
      updateUserProfile(
        userRole: $userRole
        userStatus: $userStatus
        appMode: $appMode
        showTeam: $showTeam
        showAll: $showAll
        userId: $userId
      )
    }
  `;
}
